import quickwash1 from '../../../media/experience/quickwash/detailer_customer_sim.jpeg';
import quickwashHero from '../../../media/experience/quickwash/dev-workspace.jpeg';
import quickwashJ from '../../../media/experience/quickwash/quickwash-j.jpeg';
import zoomCall from '../../../media/experience/quickwash/jan-30.png';
import quickwashPoster from '../../../media/experience/quickwash/max_zoom.png';


const quickwashData = {
    company: "QuickWash",
    slug: "quickwash",
    poster: quickwashPoster,
    location: "New York, NY",
    heroImage: quickwashHero,

    roles: [
        {
            title: "Software Engineer",
            start: "January 2026",
            end: "Present",
            summary: "At QuickWash, I lead engineering across four client applications: two Flutter mobile apps (customer and detailer) and two web applications (customer-facing and admin), all synchronized through a single NestJS API backed by MySQL on AWS RDS. I shipped extensive feature work, resolved production issues, and eliminated accumulated tech debt while establishing Fastlane pipelines for iOS and Android alongside containerized CI/CD. I manage App Store releases directly and coordinate Google Play publishing, with ongoing ownership of release cycles across all four surfaces. During this work, I duplicated the full stack into isolated dev and prod environments using Terraform-managed infrastructure. I built a WebSocket layer with NestJS and Redis for real-time synchronization, defensive model serialization to prevent mobile crashes from schema changes, and idempotent navigation logic to resolve race conditions. The API includes job matching, dispatch, dynamic pricing, geofenced availability, and orchestration for live upsells, cancellations, and payout splits. I migrated the platform from a single-EC2 monolith to AWS (RDS, S3, OpenSearch, SNS) and reduced cloud spend by roughly 50% through instance right-sizing, RDS query tuning, S3 lifecycle policies, and OpenSearch index cleanup. Mobile development uses Flutter and GetX with Stripe Connect, Google Maps, Stripe Identity, and Checkr onboarding. For observability, I integrated Firebase Crashlytics and AWS CloudWatch with correlation IDs and booking-level context, plus an incident workflow that cross-references logs, crash data, production records, and payment trails. I integrated Linear for product management and built Cursor Cloud Agents to triage tickets against dev and prod environments, with autonomous handling where appropriate and direct ownership of complex issues. I also maintain automations for ongoing codebase health. Additional integrations include Meta SDK, Amplitude, AWS SNS for SMS OTP, and Figma-to-code workflows through Figma MCP and Cursor.",
        },
    ],

    techStack: [
        "Flutter (Dart)",
        "NestJS (TypeScript)",
        "GetX (Reactive State)",
        "Redis (Pub/Sub & Sync)",
        "WebSocket (Socket.io)",
        "MySQL / MariaDB (TypeORM)",
        "Stripe Connect (Express Payouts)",
        "Stripe Identity (KYC Verification)",
        "AWS (EC2, RDS, S3, OpenSearch, SNS)",
        "AWS CloudWatch",
        "AWS Cost Optimization",
        "App Store Connect (iOS Deployment)",
        "Google Play Console (Partner Coord.)",
        "Firebase (Auth, FCM, Crashlytics)",
        "BullMQ (Distributed Tasks)",
        "OneSignal",
        "Amplitude",
        "Meta SDK",
        "Docker",
        "Terraform (IaC)",
        "Fastlane (iOS & Android)",
        "CI/CD (GitHub Actions)",
        "Linear (Product Management)",
        "Cursor Cloud Agents",
        "Figma"
    ],

    gallery: [
        { type: 'image', src: quickwashHero, alt: 'QuickWash development with detailer app on monitor' },
        { type: 'image', src: quickwash1, alt: 'QuickWash Customer and Detailer Simulator Apps' },
        { type: 'image', src: quickwashJ, alt: 'Multi-monitor development setup for QuickWash' },
        { type: 'image', src: zoomCall, alt: 'Zoom call with team' }
    ],

    links: {
        company: "https://quickwashtech.com/",
        apps: [
            { label: "Detailer OS", href: "https://apps.apple.com/us/app/detailer-os/id6739266061" },
            { label: "QuickWash", href: "https://apps.apple.com/us/app/quickwash-on-demand-carwash/id6751733566" },
        ],
    }
};

export default quickwashData;